import { render, staticRenderFns } from "./EventModalDocumentsContentActs.vue?vue&type=template&id=63f987c0&scoped=true"
import script from "./EventModalDocumentsContentActs.vue?vue&type=script&lang=js"
export * from "./EventModalDocumentsContentActs.vue?vue&type=script&lang=js"
import style0 from "./EventModalDocumentsContentActs.vue?vue&type=style&index=0&id=63f987c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f987c0",
  null
  
)

export default component.exports